import { useFillQueueStore } from '../../store/useFillQueueStore'

// Cache-bust suffix pro chartUrl (viz doc/plans/to-fill-data-fetching.md, krok 13).
// Graf renderuje cw-charts server-side z DB, ne z klientských dat — po dokončení
// dotahování (fronta doběhla a aspoň jedna řada se dotáhla) ho přenačteme jednou
// přidáním `&_fill=<timestamp>` do URL.
//
// Použití:  const bust = useChartFillBust()
//           const url = baseUrl + bust
export function useChartFillBust() {
  const lastFilledAt = useFillQueueStore((s) => s.lastFilledAt)
  return lastFilledAt ? `&_fill=${lastFilledAt}` : ''
}
